import { Button, useNavigate } from '@forgeglobal/design-framework';
import { find } from 'lodash';
import { useContext, useEffect } from 'react';
import { NotificationContext } from '../providers/NotificationProvider';
import { isTemporaryAccount } from '../utils/accountUtils';
import useAccounts from './useAccounts';

const useBeneficiariesNotifications = () => {
  const { addNotifications } = useContext(NotificationContext);

  const { data: accounts, loading } = useAccounts({ enabled: false });

  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      return;
    }

    var anyAccountMissingBeneficiaries = false;

    var notifications = accounts?.reduce((accumulator, account) => {
      if (isTemporaryAccount(account?.accountNumber)) {
        return accumulator;
      }

      const hasBeneficiaries =
        account?.primaryBeneficiaries.length > 0 ||
        account?.contingentBeneficiaries.length > 0;

      if (hasBeneficiaries) {
        return accumulator;
      }

      anyAccountMissingBeneficiaries = true;

      return [
        ...accumulator,
        {
          text: `Your account is missing beneficiary information. Add a beneficiary now to complete your account.`,
          status: 'warning',
          action: (
            <Button
              onClick={() =>
                navigate(
                  `/accounts/${account?.accountNumber}/details?dialog=beneficiary-${account?.accountNumber}`,
                )
              }
              variant="text"
              color="primary"
              data-test-id="notifications-banner-button">
              Add Beneficiaries
            </Button>
          ),
          type: 'beneficiary',
          id: account.accountNumber,
        },
      ];
    }, []);

    if (anyAccountMissingBeneficiaries) {
      const firstAccount = find(
        accounts,
        ({ accountNumber, primaryBeneficiaries, contingentBeneficiaries }) =>
          !isTemporaryAccount(accountNumber) &&
          !(
            primaryBeneficiaries.length > 0 ||
            contingentBeneficiaries.length > 0
          ),
      );

      notifications = [
        {
          text: `One or more of your accounts are missing beneficiary information. Add beneficiaries now to complete your accounts.`,
          status: 'warning',
          action: (
            <Button
              onClick={() =>
                navigate(
                  `/accounts/${firstAccount.accountNumber}/details?dialog=beneficiary-${firstAccount.accountNumber}`,
                )
              }
              variant="text"
              color="primary"
              data-test-id="notifications-banner-button">
              Add Beneficiaries
            </Button>
          ),
          type: 'beneficiary',
        },
        ...notifications,
      ];
    }

    if (notifications && notifications.length > 0) {
      addNotifications(notifications, true, true);
    }
  }, [loading, accounts]);
};

export default useBeneficiariesNotifications;
